import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'In welke gebieden is Nexon Service actief?',
      answer: 'Nexon Service is actief in heel Nederland en de Benelux (België en Duitsland). Wij verzorgen zowel lokale transporten binnen Rotterdam als internationale leveringen door de hele Benelux.'
    },
    {
      question: 'Werken jullie ook voor particulieren?',
      answer: 'Jazeker! Wij werken voor zowel bedrijven (B2B) als particulieren (B2C). Of het nu gaat om een complete verhuizing, het transporteren van een grote aankoop of het installeren van meubels – wij helpen u graag.'
    },
    {
      question: 'Hoe snel kunnen jullie een opdracht uitvoeren?',
      answer: 'Dit hangt af van de beschikbaarheid en de omvang van de opdracht. Voor spoedopdrachten doen wij ons best om dezelfde of volgende dag te leveren. Neem contact met ons op voor de actuele planning.'
    },
    {
      question: 'Zijn jullie verzekerd voor transport en schade?',
      answer: 'Ja, wij zijn volledig verzekerd. Al onze transporten en werkzaamheden zijn gedekt door een beroepsaansprakelijkheidsverzekering. Uw goederen zijn in veilige handen.'
    },
    {
      question: 'Kan ik een langdurige samenwerking aangaan?',
      answer: 'Absoluut! Wij staan open voor langdurige samenwerkingen en bieden aantrekkelijke voorwaarden voor vaste klanten, zoals vaste tarieven, prioriteit in planning en een vast contactpersoon.'
    },
    {
      question: 'Hoe kan ik een offerte aanvragen?',
      answer: 'U kunt eenvoudig een offerte aanvragen via ons online formulier, per e-mail (info@NexonService.nl) of telefonisch (0651929275). Wij reageren meestal binnen 24 uur met een vrijblijvende offerte.'
    }
  ];

  return (
    <section className="py-14 lg:py-20 bg-neutral-50 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-yellow-100/30 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left header */}
          <div className="lg:sticky lg:top-32">
            <span className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-400 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <HelpCircle className="w-4 h-4" />
              Veelgestelde vragen
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-neutral-900 mb-6 leading-tight">
              Heeft u nog
              <span className="gradient-text"> vragen?</span>
            </h2>
            <p className="text-xl text-neutral-600 leading-relaxed mb-8">
              Hieronder vindt u antwoorden op de meest gestelde vragen. Staat uw vraag er niet bij? Neem gerust contact met ons op!
            </p>
            <div className="bg-white p-6 rounded-2xl shadow-lg border border-neutral-100">
              <p className="font-semibold text-neutral-900 mb-2">Nog andere vragen?</p>
              <p className="text-neutral-600 text-sm mb-4">Wij helpen u graag verder.</p>
              <div className="space-y-2 text-sm">
                <a href="tel:0651929275" className="flex items-center gap-2 text-yellow-400 hover:text-yellow-400 font-medium">
                  📞 0651929275
                </a>
                <a href="mailto:info@NexonService.nl" className="flex items-center gap-2 text-yellow-400 hover:text-yellow-400 font-medium">
                  ✉️ info@NexonService.nl
                </a>
              </div>
            </div>
          </div>

          {/* Right FAQ accordion */}
          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div 
                key={idx}
                className={`bg-white rounded-2xl overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'shadow-xl border-2 border-yellow-100' : 'shadow-md border-2 border-transparent hover:border-neutral-100'
                }`}
              >
                <button
                  onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                  className="w-full p-6 flex items-center justify-between text-left"
                >
                  <span className="font-bold text-neutral-900 pr-4">{faq.question}</span>
                  <div className={`w-10 h-10 bg-neutral-100 rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                    openIndex === idx ? 'bg-yellow-400 rotate-180' : ''
                  }`}>
                    <ChevronDown className={`w-5 h-5 transition-colors ${
                      openIndex === idx ? 'text-white' : 'text-neutral-500'
                    }`} />
                  </div>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-6' : 'max-h-0'
                }`}>
                  <p className="px-6 text-neutral-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
